import {
  Box,
  Button,
  Hidden,
  IconButton,
  makeStyles,
  useTheme,
  useMediaQuery,
  Grid,
  Drawer,
  ButtonGroup,
  Container,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { CgMenuGridR } from "react-icons/cg";
import { AdCards, Notifications, Profile, Settings } from "./components";
import { useSelector, useDispatch } from "react-redux";
import {} from "../../../redux-store/customer/customer";
import tabs from "./tabs";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "220px",
    height: "100%",
    backgroundColor: "black",
    color: "white",
  },
  tabs: {
    marginTop: "30px",
  },
  tabBtn: {
    color: "black",
    // backgroundColor: 'red',
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    padding: "10px",
  },
  drawerBtn: {
    color: "white",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    padding: "10px",
  },
  activeTabBtn: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "flex-start",
    padding: "10px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

function Eksplode() {
  const [openTab, setOpenTab] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const state = useSelector((state) => state.eksplode);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [tabPanelIndex, setTabPanelIndex] = useState(0);
  const toggleTabView = () => {
    setOpenTab(!openTab);
  };
  const handleTabOpen = () => {
    setOpenTab(true);
  };
  const handleTabClose = () => {
    setOpenTab(false);
  };
  return (
    <div>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Hidden only={["lg", "xl", "md"]}>
          <IconButton
            onClick={toggleTabView}
            style={{
              backgroundColor: theme.palette.primary.main,
              marginTop: "-25px",
            }}
          >
            <CgMenuGridR />
          </IconButton>
        </Hidden>
      </Box>

      <Hidden only={["lg", "xl", "md"]}>
        <Drawer
          classes={{ paper: classes.drawer, modal: classes.drawerModal }}
          anchor="left"
          open={isDesktop ? true : openTab}
          variant={isDesktop ? "permanent" : "temporary"}
          onClose={handleTabClose}
        >
          {tabs.map((tab, index) => (
            <Button
              startIcon={
                tab.panel === tabPanelIndex ? tab.activeIcon : tab.icon
              }
              key={index}
              className={
                tab.panel === tabPanelIndex
                  ? classes.activeTabBtn
                  : classes.drawerBtn
              }
              onClick={() => {
                setTabPanelIndex(tab.panel);
                handleTabClose();
              }}
              align="left"
              fullWidth
            >
              {tab.name}
            </Button>
          ))}
        </Drawer>
      </Hidden>
      <Grid container spacing={5}>
        <Grid item xs={12} md={3} lg={2}>
          <Hidden only={["xs", "sm"]}>
            <div className={classes.tabs}>
              <ButtonGroup orientation="vertical" fullWidth>
                {tabs.map((tab, index) => (
                  <Button
                    startIcon={
                      tab.panel === tabPanelIndex ? tab.activeIcon : tab.icon
                    }
                    key={index}
                    className={
                      tab.panel === tabPanelIndex
                        ? classes.activeTabBtn
                        : classes.tabBtn
                    }
                    onClick={() => setTabPanelIndex(tab.panel)}
                    align="left"
                    fullWidth
                  >
                    {tab.name}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
          </Hidden>
        </Grid>
        <Grid item xs={12} md={9} lg={10}>
          {tabPanelIndex === 0 && <Profile />}
          {tabPanelIndex === 4 && (
            <Notifications notifications={state.notifications} />
          )}
          {tabPanelIndex === 2 && <AdCards />}
          {tabPanelIndex === 3 && <Settings />}
        </Grid>
      </Grid>
    </div>
  );
}

export default Eksplode;
